import { ReactNode } from 'react'

export const NavigationScroll = (props: { children: ReactNode }) => {
  const { children } = props

  return children || null
}
